/* eslint-disable react-hooks/exhaustive-deps */

import { useLocation, Link } from "react-router-dom";
import FacilitiesCard from "../FacilitiesCard";
import { WebsiteLayout } from "../Layouts/WebsiteLayout";
import { useEffect, useMemo, useState } from "react";
import { Booking } from "../../service/booking";
import BookingForm from "../BookingForm";
import classNames from "classnames";
import { toast } from "react-toastify";
import { useCheckScreenWidth } from "../../componentsUpdated/utils/useCheckScreenWidth";
import Drawer from "@mui/material/Drawer";
import { SliderComponent } from "../Filter/Slider";
import { InputFilter } from "../Filter/Input";
import ServicesCard from "./ServicesCard";

const HealthCareFacilities = ({
  isLogged = false,
  page = "/facilities",
  cartItems,
  handleCartItems,
  roleId = 5,
  userProfileId = 160,
}) => {
  const location = useLocation();
  const screenWidth = useCheckScreenWidth();
  const isTab = screenWidth <= 1279;
  const queryParams = new URLSearchParams(location.search);
  const queryString = new URLSearchParams(queryParams).toString();

  const [facilities, setFacilities] = useState([]);
  const [facilityServices, setFacilityServices] = useState([]);
  const [isCardId, setIsCardId] = useState(null);
  const [serviceLoading, setServiceLoading] = useState(false);
  const [facilityLoading, setFacilityLoading] = useState(false);
  const [calender, setCalendar] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };
  const [filters, setFilters] = useState({
    price: {
      min: 0,
      max: 500,
    },
    name: "",
  });
  const filteredFacilities = useMemo(() => {
    const allFilters = Object.keys(filters);
    let data = [...facilities];
    allFilters.forEach((filter) => {
      if (filter === "price") {
        data = data.filter((item) => {
          // Parse services if it's a JSON string
          let services = item.services;
          if (typeof services === "string") {
            try {
              services = JSON.parse(services);
            } catch (e) {
              services = [];
            }
          }

          // Safely extract price with proper optional chaining
          const price = services?.at?.(0)?.svc_cost_amt;

          // If price is undefined or null, include the facility in results
          // (don't filter it out based on price)
          if (price === undefined || price === null) {
            return true;
          }

          // Otherwise, apply the price range filter
          return price >= filters.price.min && price <= filters.price.max;
        });
      } else if (filter === "name") {
        data = data.filter((item) => {
          const svcf_name = item?.svcf_name || "";
          return svcf_name.toLowerCase().includes(filters.name.toLowerCase());
        });
      }
    });
    return data;
  }, [facilities, filters]);

  const handleCardClick = (cardId) => {
    setIsCardId(cardId);
  };

  const handleFilters = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };
  const svc_type_id = queryParams.get("svc_type_id");
  const iso_city_id = queryParams.get("iso_city_id");
  const iso_cntry_id = queryParams.get("iso_cntry_id");
  const svc_provider_name = queryParams.get("svc_provider_name");
  const payload = {
    role_id: roleId,
    sys_user_id: userProfileId,
  };
  if (svc_provider_name) {
    payload.svc_provider_name = svc_provider_name;
  }
  if (iso_cntry_id) {
    payload.iso_cntry_id = iso_cntry_id;
  }
  if (iso_city_id) {
    payload.iso_city_id = iso_city_id;
  }
  if (svc_type_id) {
    payload.svc_type_id = svc_type_id;
  }

  const getFacilities = async () => {
    try {
      setFacilityLoading(true);
      const response = await Booking.getFacilities({ ...payload });

      if (response?.status === 200 && response?.data?.usr?.rec) {
        setFacilities([...response?.data?.usr?.rec]);
      }
      if (response?.data?.usr?.rec?.length > 0 && !isTab) {
        setIsCardId(response?.data?.usr?.rec?.at(0)?.svcf_id);

        // Parse calendar if it's a JSON string
        let calendar = response?.data?.usr?.rec?.at(0)?.calendar;
        if (typeof calendar === "string") {
          try {
            calendar = JSON.parse(calendar);
          } catch (e) {
            calendar = [];
          }
        }
        setCalendar(calendar);
      }
    } catch (error) {
      toast.error(error.response?.data?.usr?.message);
    } finally {
      setFacilityLoading(false);
    }
  };

  const getService = async () => {
    try {
      setServiceLoading(true);
      const response = await Booking.getServices({
        svcf_id: isCardId,
        role_id: roleId,
        sys_user_id: userProfileId,
      });

      if (response?.status === 200 && response?.data?.usr?.rec) {
        setFacilityServices([...response?.data?.usr?.rec]);
      }
    } catch (error) {
      toast.error(error.response?.data?.usr?.message);
    } finally {
      setServiceLoading(false);
    }
  };

  const wrapWithDrawer = (component, anchor, open, onClose) => {
    return isTab ? (
      <Drawer
        anchor={anchor}
        open={open}
        onClose={onClose}
        className="col-span-3"
      >
        <button
          className="bg-red-500 text-white py-0.5 px-3 text-lg rounded w-5 self-end mr-2 mt-2"
          onClick={onClose}
        >
          <div className="flex justify-center items-center">x</div>
        </button>
        <div className=" h-full px-2 w-[80vw] md:w-[40vw] md:px-5 overflow-y-auto shadow-md">
          {component}
        </div>
      </Drawer>
    ) : (
      <div className=" h-full px-2 md:px-5 overflow-y-auto shadow-md col-span-3">
        {component}
      </div>
    );
  };

  useEffect(() => {
    getService(isCardId);
  }, [isCardId]);

  useEffect(() => {
    getFacilities();
  }, [queryString]);

  const wrapWithLayout = (isLogged, children) => {
    if (isLogged) {
      return <div className={"md:px-10 px-8"}>{children}</div>;
    } else {
      return (
        <WebsiteLayout className={"bg-lightGray"}>
          <div className={"px-7 md:px-10 2xl:px-24"}>{children}</div>
        </WebsiteLayout>
      );
    }
  };
  return wrapWithLayout(
    isLogged,
    <>
      <div
        className={classNames(
          "grid h-screen transition-all duration-300 ease-in-out grid-cols-12 md:gap-8 mt-6"
        )}
      >
        <div className="hidden lg:block md:col-span-3 lg:col-span-2">
          <div className="rounded-3xl overflow-hidden border h-40 mb-6 relative">
            <img
              src="/images/staticmap.png"
              alt="dummy map"
              className="h-full w-full object-cover"
            />
            <Link
              to={`${page}/map?${queryString}`}
              className="flex absolute z-50 bg-white bottom-0 justify-center h-min items-center w-full p-2"
            >
              View In Map
            </Link>
          </div>
          <div className="mb-4">
            <div className="mb-2 font-semibold">My prefered provider name</div>
            <InputFilter
              value={filters.name}
              handleChange={(data) => handleFilters("name", data)}
            />
          </div>
          <div className="mt-2 mb-4 font-semibold">My prefered Price range</div>
          <SliderComponent
            handleChange={(data) => handleFilters("price", data)}
            values={filters.price}
            range={{ min: 0, max: 500 }}
          />
        </div>
        {/* Card List Section */}
        <div
          className={classNames(
            " h-full overflow-y-auto transition-all duration-300 col-span-12 md:col-span-12 lg:col-span-10 xl:col-span-7"
          )}
        >
          <div className="pt-0 md:pt-15">
            <BookingForm
              showTitle={false}
              blackSeparation={true}
              page={page}
              userProfileId={userProfileId}
              roleId={roleId}
            />
          </div>
          <div className="block lg:hidden mt-4">
            <div className="flex w-full text-sm md:text-base gap-4 justify-between">
              <Link
                to={`${page}/map?${queryString}`}
                className="bg-darkBlue text-white capitalize py-1.5 rounded-md px-6 text-center gap-2 flex justify-center items-center"
              >
                View In Map
              </Link>
              <button
                className="bg-darkBlue text-white capitalize py-1.5 !rounded-md px-6 text-center gap-2 flex justify-center items-center"
                onClick={toggleDropdown}
              >
                {isDropdownOpen ? "Hide Filters" : "Show Filters"}
              </button>
            </div>
            <div className="px-3">
              {isDropdownOpen && (
                <div className="mt-4">
                  <div className="mb-4">
                    <div className="mb-2 font-semibold">
                      My prefered provider name
                    </div>
                    <InputFilter
                      value={filters.name}
                      handleChange={(data) => handleFilters("name", data)}
                    />
                  </div>
                  <div className="mt-2 mb-4 font-semibold">
                    My prefered Price range
                  </div>
                  <SliderComponent
                    handleChange={(data) => handleFilters("price", data)}
                    values={filters.price}
                    range={{ min: 0, max: 500 }}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="text-xl justify-between sm:text-2xl w-full whitespace-wrap font-semibold py-7 flex">
            Your list of available providers
          </div>
          <div className="flex space-y-10 flex-col">
            {facilityLoading ? (
              <p className="w-full text-lg font-semibold text-center">
                Loading
              </p>
            ) : filteredFacilities.length > 0 ? (
              filteredFacilities?.map((ele) => {
                const address = `${ele?.svcf_addr_street1}, ${ele?.iso_city_name}, ${ele?.iso_cntry_name}`;

                // Parse services if it's a JSON string
                let services = ele.services;
                if (typeof services === "string") {
                  try {
                    services = JSON.parse(services);
                  } catch (e) {
                    services = [];
                  }
                }

                // Parse calendar if it's a JSON string
                let calendar = ele.calendar;
                if (typeof calendar === "string") {
                  try {
                    calendar = JSON.parse(calendar);
                  } catch (e) {
                    calendar = [];
                  }
                }

                return (
                  <div
                    key={ele.svcf_id}
                    onClick={() => {
                      handleCardClick(ele?.svcf_id);
                      setCalendar(calendar);
                    }}
                    className="cursor-pointer"
                  >
                    <FacilitiesCard
                      isSelected={ele?.svcf_id === isCardId}
                      id={ele?.svcf_id}
                      facilityName={ele?.svcf_name}
                      isVerified={ele?.svcf_verifier_notes_txt}
                      description={ele?.svcft_typ_desc}
                      facilityDesc={ele?.svcf_desc}
                      phone={ele?.svcf_contact_phone_nbr}
                      address={address}
                      avatar={ele?.svcf_photo}
                      price={services?.at?.(0)?.svc_cost_amt || 0}
                    />
                  </div>
                );
              })
            ) : (
              <p className="w-full text-lg font-semibold text-center">
                No Facilites Found
              </p>
            )}
          </div>
        </div>
        {wrapWithDrawer(
          <div className="text-center col-span-3">
            {!serviceLoading ? (
              facilityServices?.map((ele) => (
                <div key={ele.svc_id}>
                  <ServicesCard
                    cartItems={cartItems}
                    data={ele}
                    cardId={isCardId}
                    handleClick={handleCartItems}
                    calender={calender}
                  />
                </div>
              ))
            ) : (
              <div className="mt-20 col-span-3">Loading ....</div>
            )}
          </div>,
          "right",
          isCardId !== null,
          () => setIsCardId(null)
        )}
      </div>
    </>
  );
};

export default HealthCareFacilities;
